import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {Roles} from '@core/enums/Roles';
import {UserStorageService} from '@services/local-storage/user-storage/user-storage.service';

// Il backend applica comunque gli stessi permessi: le guardie evitano solo pagine inutilizzabili.
// inject() solo prima del primo await: dopo si e' fuori dal contesto di injection.

async function roleOf(): Promise<Roles | undefined> {
  const user = await inject(UserStorageService).getUserStorage();
  return user?.roles?.id as Roles | undefined;
}

/** Back office: amministratori DigitalMens e aziendali, gestori documenti. */
export const adminGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const role = await roleOf();
  const allowed = [Roles.SUPER_ADMIN, Roles.MANAGEMENT_SYSTEM, Roles.OPERATOR_BO].includes(role as Roles);
  return allowed || router.createUrlTree(['/documents']);
};

/** Gestione utenti: amministratori DigitalMens e aziendali. */
export const companyAdminGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const role = await roleOf();
  return role === Roles.SUPER_ADMIN || role === Roles.MANAGEMENT_SYSTEM || router.createUrlTree(['/admin/documents']);
};

/** Gestione aziende: solo l'amministratore DigitalMens. */
export const platformAdminGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const role = await roleOf();
  return role === Roles.SUPER_ADMIN || router.createUrlTree(['/admin/documents']);
};
